import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Input, Text } from "@fragments";
import { CategoryRounded } from "@mui/icons-material";

import getCategories from "../enums/categories";

export default function SelectCategories({ value, onChange }) {
    const { t } = useTranslation("contentModals");
    const [localCategories, setLocalCategories] = useState(value);

    const categories = useMemo(() => getCategories(t), [t]);

    useEffect(() => {
        onChange(localCategories);
    }, [localCategories]);

    const handleCategoryChange = (selected) => {
        setLocalCategories([...selected]);
    };

    return (
        <div className="mt-4 mb-1">
            <Text.h3
                value={t("manageContent.categories.title")}
                left={<CategoryRounded />}
                className="mb-1 mt-3"
            />
            <Text.h5 contrast={5}>{t("manageContent.categories.subtitle")}</Text.h5>
            <Input.SelectOptions
                className="mt-2"
                label={t("manageContent.categories.selectLabel")}
                options={categories}
                value={localCategories}
                onInput={handleCategoryChange}
                maxItems={3}
            />
        </div>
    );
}
